import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_CopyHeading = _resolveComponent("CopyHeading")!
  const _component_CopyBody = _resolveComponent("CopyBody")!
  const _component_CTASubLabel = _resolveComponent("CTASubLabel")!
  const _component_CTAButton = _resolveComponent("CTAButton")!
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_GalleryImage = _resolveComponent("GalleryImage")!
  const _component_GalleryGrid = _resolveComponent("GalleryGrid")!
  const _component_CopyOverline = _resolveComponent("CopyOverline")!
  const _component_CopySubHeading = _resolveComponent("CopySubHeading")!
  const _component_LandingSection = _resolveComponent("LandingSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createVNode(_component_BrandLogo),
      _createVNode(_component_HeroSection, null, {
        default: _withCtx(() => [
          _createVNode(_component_CopyHeading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.hero.headline), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CopyBody, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.hero.copyHero), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CTAButton, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.download.label) + " ", 1),
              _createVNode(_component_CTASubLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.download.subLabel), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CTAButton, {
            theme: "secondary",
            padding: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.about.label), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_LandingSection, null, {
        default: _withCtx(() => [
          _createVNode(_component_GalleryGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_GalleryImage, {
                src: _ctx.main.womanInVideoCall,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode(_component_GalleryImage, {
                src: _ctx.main.womenVideochatting,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode(_component_GalleryImage, {
                src: _ctx.main.menInMeeting,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode(_component_GalleryImage, {
                src: _ctx.main.manTexting,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_CopyOverline, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.main.overline), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CopySubHeading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.main.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CopyBody, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.main.copy.replace('-', '‑')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("footer", null, [
      _createVNode(_component_LandingSection, {
        theme: "dark",
        footer: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CopySubHeading, { theme: "light" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.footer.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CopyBody, { theme: "light" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.footer.copy), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CTAButton, { theme: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.download.label) + " ", 1),
              _createVNode(_component_CTASubLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.download.subLabel), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}